import React, { useState, useEffect } from "react";
import axios from "axios";
import A1 from '../Images/elo.png'; // same logo as WhatsApp login

const PasswordChange = () => {
    const [mobile, setMobile] = useState("");
    const [table, setTable] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const otpUser = sessionStorage.getItem("otpUser");
        if (otpUser) {
            const data = JSON.parse(otpUser);
            setMobile(data.mobile);
            setTable(data.table);
        }
    }, []);

    const handleChangePassword = async () => {
        if (!newPassword || !confirmPassword) {
            setMessage("Enter both password fields.");
            return;
        }

        if (newPassword !== confirmPassword) {
            setMessage("Passwords do not match.");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                "https://cloudapi.emedhatechnologies.com/pages/api/api/change-password",
                {
                    mobile,
                    newPassword,
                    confirmPassword,
                    table
                }
            );

            setLoading(false);

            if (response.data.success) {
                setMessage(response.data.message);
                sessionStorage.removeItem("otpUser");
                setTimeout(() => {
                    window.location.href = "/login";
                }, 1500);
            } else {
                setMessage(response.data.message);
            }
        } catch (error) {
            setLoading(false);
            setMessage(error.response?.data?.message || "Server error. Try again.");
        }
    };

    // return (
    //     <div
    //         style={{
    //             display: "flex",
    //             justifyContent: "center",
    //             marginTop: "50px",
    //             fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    //             fontSize: "12px",
    //             color: "#333",
    //             padding: "20px",
    //             width: "100%",
    //             boxSizing: "border-box",
    //         }}
    //     >
    //         <div
    //             style={{
    //                 width: "100%",
    //                 maxWidth: "400px",
    //                 backgroundColor: "#fff",
    //                 border: "1px solid #ccc",
    //                 borderRadius: "10px",
    //                 padding: "30px",
    //                 boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    //                 boxSizing: "border-box",
    //             }}
    //         >
    //             {/* Logo */}
    //             <img
    //                 src={A1}
    //                 alt="Logo"
    //                 style={{ height: "40px", display: "block", margin: "0 auto 20px" }}
    //             />

    //             <h1
    //                 style={{
    //                     textAlign: "center",
    //                     fontSize: "32px",
    //                     fontFamily: '"Trebuchet MS", sans-serif',
    //                     margin: "0 0 30px",
    //                 }}
    //             >
    //                 <strong>Change Password</strong>
    //             </h1>

    //             {/* Mobile Number */}
    //             <input
    //                 type="text"
    //                 placeholder="Your mobile number"
    //                 value={mobile}
    //                 disabled
    //                 style={{
    //                     width: "100%",
    //                     padding: "10px",
    //                     margin: "10px 0",
    //                     borderRadius: "4px",
    //                     border: "1px solid #ccc",
    //                     fontSize: "12px",
    //                     backgroundColor: "#f0f0f0",
    //                     boxSizing: "border-box",
    //                 }}
    //             />

    //             {/* New Password */}
    //             <input
    //                 type="password"
    //                 placeholder="New Password"
    //                 value={newPassword}
    //                 onChange={(e) => setNewPassword(e.target.value)}
    //                 style={{
    //                     width: "100%",
    //                     padding: "10px",
    //                     margin: "10px 0",
    //                     borderRadius: "4px",
    //                     border: "1px solid #ccc",
    //                     fontSize: "12px",
    //                     boxSizing: "border-box",
    //                 }}
    //             />

    //             {/* Confirm Password */}
    //             <input
    //                 type="password"
    //                 placeholder="Confirm Password"
    //                 value={confirmPassword}
    //                 onChange={(e) => setConfirmPassword(e.target.value)}
    //                 style={{
    //                     width: "100%",
    //                     padding: "10px",
    //                     margin: "10px 0",
    //                     borderRadius: "4px",
    //                     border: "1px solid #ccc",
    //                     fontSize: "12px",
    //                     boxSizing: "border-box",
    //                 }}
    //             />

    //             {/* Change Password Button */}
    //             <div style={{ textAlign: "center", margin: "15px 0" }}>
    //                 <button
    //                     onClick={handleChangePassword}
    //                     disabled={loading}
    //                     style={{
    //                         width: "100%",
    //                         padding: "10px",
    //                         backgroundColor: "#07526f",
    //                         color: "#fff",
    //                         border: "none",
    //                         borderRadius: "4px",
    //                         cursor: "pointer",
    //                         fontSize: "12px",
    //                     }}
    //                 >
    //                     {loading ? "Changing..." : "Change Password"}
    //                 </button>
    //             </div>

    //             {/* Message */}
    //             {message && (
    //                 <div
    //                     style={{
    //                         textAlign: "center",
    //                         color: "#ff0000",
    //                         fontSize: "12px",
    //                         marginBottom: "10px",
    //                     }}
    //                 >
    //                     {message}
    //                 </div>
    //             )}
    //         </div>
    //     </div>
    // );

    return (
    <div
        style={{
            minHeight: "100vh",
            width: "100%",
            backgroundColor: "#f8fafc",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "24px",
            fontFamily: "monospace",
            color: "#0f172a",
            overflowY: "auto",
            boxSizing: "border-box",
        }}
    >
        {/* Header */}
        <header
            style={{
                width: "100%",
                maxWidth: "1280px",
                margin: "0 auto",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e2e8f0",
                paddingBottom: "24px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                }}
            >
                <img
                    src={A1}
                    alt="Logo"
                    style={{
                        height: "40px",
                    }}
                />

                <span
                    style={{
                        fontWeight: "700",
                        fontSize: "12px",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                    }}
                >
                    Cloud Connect
                </span>
            </div>
        </header>

        {/* Main */}
        <main
            style={{
                width: "100%",
                maxWidth: "400px",
                margin: "40px auto",
                padding: "16px 0",
            }}
        >
            {/* Title */}
            <div style={{ marginBottom: "32px" }}>
                <h1
                    style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                        marginBottom: "8px",
                    }}
                >
                    Password Reset
                </h1>

                <p
                    style={{
                        fontSize: "12px",
                        color: "#94a3b8",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        lineHeight: "1.6",
                    }}
                >
                    Create a new secure password
                </p>
            </div>

            {/* Mobile Number */}
            <div style={{ marginBottom: "20px" }}>
                <label
                    style={{
                        display: "block",
                        marginBottom: "8px",
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#64748b",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                    }}
                >
                    Mobile Number
                </label>

                <input
                    type="text"
                    value={mobile}
                    disabled
                    style={{
                        width: "100%",
                        height: "44px",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        padding: "0 15px",
                        fontSize: "12px",
                        backgroundColor: "#f1f5f9",
                        color: "#64748b",
                        boxSizing: "border-box",
                        outline: "none",
                    }}
                />
            </div>

            {/* New Password */}
            <div style={{ marginBottom: "20px" }}>
                <label
                    style={{
                        display: "block",
                        marginBottom: "8px",
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#64748b",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                    }}
                >
                    New Password
                </label>

                <input
                    type="password"
                    placeholder="Enter New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    style={{
                        width: "100%",
                        height: "44px",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        padding: "0 15px",
                        fontSize: "12px",
                        backgroundColor: "#fff",
                        boxSizing: "border-box",
                        outline: "none",
                    }}
                />
            </div>

            {/* Confirm Password */}
            <div style={{ marginBottom: "24px" }}>
                <label
                    style={{
                        display: "block",
                        marginBottom: "8px",
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#64748b",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                    }}
                >
                    Confirm Password
                </label>

                <input
                    type="password"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={{
                        width: "100%",
                        height: "44px",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        padding: "0 15px",
                        fontSize: "12px",
                        backgroundColor: "#fff",
                        boxSizing: "border-box",
                        outline: "none",
                    }}
                />
            </div>

            {/* Button */}
            <button
                onClick={handleChangePassword}
                disabled={loading}
                style={{
                    width: "100%",
                    height: "44px",
                    backgroundColor: "#000",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: loading ? "not-allowed" : "pointer",
                    fontSize: "12px",
                    fontWeight: "700",
                    textTransform: "uppercase",
                    letterSpacing: "2px",
                    opacity: loading ? 0.7 : 1,
                }}
            >
                {loading ? "Changing..." : "Change Password"}
            </button>

            {/* Message */}
            {message && (
                <div
                    style={{
                        marginTop: "20px",
                        textAlign: "center",
                        color: "#dc2626",
                        fontSize: "12px",
                    }}
                >
                    {message}
                </div>
            )}

            {/* Bottom Text */}
            <div
                style={{
                    marginTop: "24px",
                    paddingTop: "24px",
                    borderTop: "1px solid #e2e8f0",
                }}
            >
                <p
                    style={{
                        fontSize: "9px",
                        color: "#94a3b8",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                        textAlign: "center",
                        lineHeight: "1.8",
                    }}
                >
                    Password update is protected through secure encrypted
                    authentication protocols.
                </p>
            </div>
        </main>

        {/* Footer */}
        <footer
            style={{
                width: "100%",
                maxWidth: "1280px",
                margin: "0 auto",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "16px",
                borderTop: "1px solid #e2e8f0",
                paddingTop: "24px",
                fontSize: "10px",
                color: "#94a3b8",
                textTransform: "uppercase",
                letterSpacing: "2px",
            }}
        >
            <p style={{ margin: 0 }}>
                © {new Date().getFullYear()} Cloud Connect Inc.
            </p>

            <div
                style={{
                    display: "flex",
                    gap: "24px",
                }}
            >
                <a
                    href="#"
                    style={{
                        textDecoration: "none",
                        color: "#94a3b8",
                    }}
                >
                    Privacy
                </a>

                <a
                    href="#"
                    style={{
                        textDecoration: "none",
                        color: "#94a3b8",
                    }}
                >
                    Terms
                </a>
            </div>
        </footer>
    </div>
);
};

export default PasswordChange;
